import React from 'react';
import { Chip, Typography, useTheme } from '@mui/material';
import { MembershipTier } from 'types/SignUpData';

export const TIER_CONFIG: Record<
  string,
  { label: string; color: 'default' | 'warning' | 'primary' }
> = {
  'Tier 1': { label: 'Tier 1', color: 'default' },
  'Tier 2': { label: 'Tier 2', color: 'warning' },
  'Tier 3': { label: 'Tier 3', color: 'primary' },
};

export const TIER_OPTIONS: MembershipTier[] = ['Tier 1', 'Tier 2', 'Tier 3'];

const TierChip: React.FC<{ tier?: string }> = ({ tier }) => {
  const theme = useTheme();

  if (!tier) {
    return (
      <Typography variant="body2" color="text.disabled">
        —
      </Typography>
    );
  }

  const tierColor =
    tier === 'Tier 1'
      ? theme.palette.primary.main
      : tier === 'Tier 2'
      ? theme.palette.secondary.light
      : tier === 'Tier 3'
      ? theme.palette.primary.dark
      : theme.palette.grey[500];

  return (
    <Chip
      label={tier}
      size="small"
      variant="outlined"
      sx={{
        borderColor: tierColor,
        color: tierColor,
        fontWeight: 'bold',
      }}
    />
  );
};

export default TierChip;
